import { Delete, Pause, SmartDisplay, } from "@mui/icons-material";
import { Box, Button, Card, Modal, Typography } from "@mui/material"
import { useRef, useState } from "react";
import { axiosInstance } from "../../utils/tokenSetCookie";
const API_BASE_URL = import.meta.env.VITE_API_BASE_URL;
import { AxiosError } from "axios";
import { toast } from "react-toastify";
import { useCart } from "../../hooks/shareContext";

interface VideoPlayerProps {
    id: number;
    videoTitle: string;
    videoUrl: string;
    // youtube?: boolean
}

export default function ExternalVideos({ data, setData }: any) {
    // console.log(data)
    const [opendeleteModal, setOpenDeleteModal] = useState(false);
    const { setMyVideosAnim, cartCount, setCartCount } = useCart();

    const stored = localStorage.getItem("myVideosAnim");
    const storedIds: number[] = stored ? JSON.parse(stored) : [];
    console.log(storedIds, "from local storage")
    const videoPlayerRef = useRef<HTMLVideoElement | null>(null);

    const [videoPlayer, setVideoPlayer] = useState<VideoPlayerProps>({
        id: data[0]?.id,
        videoTitle: data[0]?.videoTitle,
        videoUrl: data[0]?.videoUrl,
        // youtube: true,
    })

    const [playVideo, setPlayVideo] = useState(false)
    const videoUrl = videoPlayer.videoUrl;
    console.log("Original data", data)
    console.log("State data", videoPlayer)


    // function isValidYouTubeUrl(url: string) {
    //     const regex = /^(https?:\/\/)?(www\.)?(youtube\.com\/watch\?v=|youtu\.be\/)[\w-]{11}$/;
    //     return regex.test(url);
    // }

    // const handleVideo = ({ videoUrl, videoTitle }: VideoPlayerProps) => {
    //     const isYoutube = isValidYouTubeUrl(videoUrl);
    //     console.log("Youtube", isYoutube)

    //     if (isYoutube) {
    //         const parsedUrl = new URL(videoUrl);

    //         const embedURL = `https://www.youtube.com/embed/${parsedUrl.searchParams.get("v")}`;
    //         console.log(embedURL)
    //         setVideoPlayer({ ...videoPlayer, videoUrl: embedURL, videoTitle: videoTitle })
    //     }
    //     else {
    //         setVideoPlayer({ ...videoPlayer, videoTitle: videoTitle, videoUrl: videoUrl, })
    //     }
    // }


    // useEffect(() => {
    //     if (data.length > 0) {
    //         const firstVideo = data[0];
    //         const isYoutube = isValidYouTubeUrl(firstVideo.url);
    //         const initialUrl = isYoutube ? `https://www.youtube.com/embed/${new URL(firstVideo.url).searchParams.get("v")}` : firstVideo.url;
    //         setVideoPlayer({ videoTitle: firstVideo.title, videoUrl: initialUrl, id: firstVideo.id });
    //     }
    // }, [])

    const isChecked = storedIds.includes(videoPlayer.id);

    console.log("id really in shared animation", isChecked)
    const handleDeleteApi = async () => {
        try {
            const response = await axiosInstance.delete(
                `${API_BASE_URL}my-videos/delete/${videoPlayer.id}`, {
                headers: {
                    "Content-Type": "multipart/form-data",
                },
            }
            );

            if (response.status >= 200 && response.status < 300) {
                if (isChecked) {
                    const updatedIds = storedIds.filter((x) => x !== videoPlayer.id);
                    setMyVideosAnim(updatedIds);
                    const newCount = Math.max(cartCount - 1, 0);
                    setCartCount(newCount)

                }
                const updatedArray = data.filter((item: any) => item.id !== videoPlayer.id);
                setData(updatedArray);
                // console.log("API Response:", response.data);

            } else {
                console.error("API Failed:", response.status);
            }

        } catch (error) {
            const err = error as AxiosError;
            // console.log(videoPlayer.id)
            toast.error(err?.message ?? "Something went wrong");
        } finally {
            setOpenDeleteModal(prev => !prev)
            toast.success("Video Deleted Successfully!")

        }

    }
    return (

        <>
            <Modal
                open={opendeleteModal}
                onClose={() => setOpenDeleteModal(prev => !prev)}
                aria-labelledby="modal-modal-title"
                aria-describedby="modal-modal-description"
                sx={{ width: "100%", display: "flex", justifyContent: "center", alignItems: "center", overflow: "hidden", }}

            >
                <Box sx={{ bgcolor: "whitesmoke", borderRadius: "5px", width: "500px" }}>

                    <Typography sx={{ fontWeight: "bold", fontSize: "20px", p: "10px", borderBottom: "1px solid rgba(160, 160, 160, 0.47)" }}>External Videos</Typography>

                    <Box sx={{ p: "20px", }}>
                        <Box sx={{ display: "flex", justifyContent: "space-between", gap: "20px", alignItems: "center" }}>
                            <Typography sx={{ fontSize: "20px" }}>Are you sure want to delete this video?</Typography>
                        </Box>

                        <Box sx={{ mt: "30px", display: "flex", justifyContent: "end", gap: "20px" }}>
                            <Button onClick={() => setOpenDeleteModal(prev => !prev)} variant="outlined">No</Button>
                            <Button onClick={handleDeleteApi} variant="contained">Yes</Button>
                        </Box>
                    </Box>
                </Box>
            </Modal>

            < Box sx={{ display: "flex", flexDirection: { xs: "column-reverse", lg: "row" }, gap: "30px", width: "100%" }
            }>

                {data.length !== 0 ? (

                    <>
                        {/* Left Bar */}
                        < Box sx={{
                            display: 'grid',
                            gridTemplateColumns: 'repeat(1, 1fr)',
                            gap: 2,
                            width: "100%",
                            maxWidth: { xs: "100%", lg: "400px" },
                            height: "100%",
                            maxHeight: "500px",
                            overflowY: "auto",
                            // border: "1px solid red",

                        }}>
                            {data.map((video: any) => (
                                <Box key={video.id} sx={{
                                    position: "relative",
                                    overflow: "hidden",
                                    width: "100%",
                                    // maxHeight: "120px",
                                    height: "100%",
                                    borderRadius: 1,
                                    // boxShadow: 3,
                                    maxWidth: "400px",
                                    boxShadow: "0 2px 8px rgba(0,0,0,0.1)",
                                }}>
                                    <Card
                                        onClick={() => {
                                            if (video.id !== videoPlayer.id) {
                                                setPlayVideo(false);
                                            }
                                            setVideoPlayer({ ...video, title: video.videoTitle, video: video.videoUrl, id: video.id })

                                        }}
                                        key={video.id}
                                        sx={{ display: "flex", gap: "10px", bgcolor: videoPlayer.videoTitle == video.videoTitle ? "#e8f1ff" : "" }}
                                    >
                                        <Box component="img" loading="lazy" src={video.thumbImage} alt="external link image" width={120} height={120} sx={{ objectFit: "cover", backgroundSize: "cover" }} />

                                        <Box sx={{
                                            width: "100%", display: "flex", flexDirection: "column", justifyContent: "center", gap: "5px",
                                        }}>
                                            <Typography sx={{ fontWeight: "bold", fontSize: "15px", textTransform: "capitalize" }}>{video?.videoTitle}</Typography>
                                            <Typography
                                                variant="body1"
                                                sx={{

                                                    display: '-webkit-box',
                                                    WebkitLineClamp: 3, // <--- Number of lines to show
                                                    WebkitBoxOrient: 'block-x-axis',
                                                    overflow: 'hidden',
                                                    textOverflow: 'ellipsis',
                                                    color: "gray",

                                                    width: { xs: "100%", sm: "250px", md: "280px", lg: "300px" }
                                                }}
                                            >
                                                {videoUrl.length > 15 ? videoUrl.slice(0, 25) + "..." : videoUrl}

                                            </Typography>


                                            <Box sx={{ width: "90%", display: "flex", gap: "2px", alignItems: "end", justifyContent: "flex-end" }} >
                                                <SmartDisplay onClick={() => {
                                                    setPlayVideo(prev => !prev)
                                                    setTimeout(() => {
                                                        videoPlayerRef.current?.play();
                                                    }, 100);
                                                }} sx={{
                                                    display: video?.id == videoPlayer.id && playVideo ? "none" : "block",
                                                    fontSize: "25px", cursor: "pointer", "&:hover": {
                                                        color: "#1976d2",
                                                    }
                                                }} />

                                                <Pause onClick={() => {

                                                    setPlayVideo(prev => !prev)
                                                    setTimeout(() => {
                                                        if (videoPlayerRef.current?.play) {
                                                            videoPlayerRef.current?.pause();
                                                        }
                                                    }, 100);
                                                }}
                                                    sx={{ display: video?.id == videoPlayer.id && playVideo ? "block" : "none" }} />
                                                <Delete sx={{
                                                    fontSize: "25px", mr: "10px", cursor: "pointer", "&:hover": {
                                                        color: "#1976d2",
                                                    }
                                                }} onClick={() => {
                                                    setVideoPlayer({ ...video, id: video.id })
                                                    setOpenDeleteModal(prev => !prev)
                                                }} />
                                            </Box>
                                        </Box>
                                    </Card>
                                </Box>
                            ))}

                        </Box >
                        {/* Right Bar */}

                        < Box sx={{ border: "1px solid #e5e5e5", borderRadius: "10px", width: "100%" }
                        }>
                            <Box sx={{ borderRadius: "10px", overflow: "hidden", }}>

                                <Box sx={{ height: { xs: "200px", sm: "300px", md: "515px" } }}>
                                    <video
                                        ref={videoPlayerRef}
                                        width="100%"
                                        controls
                                        controlsList="nodownload"
                                        height="100%"
                                        src={videoPlayer.videoUrl}
                                        onPlay={() => setPlayVideo(true)}
                                        onPause={() => setPlayVideo(false)}
                                    />
                                </Box>


                                {/* <Box sx={{ height: { xs: "200px", sm: "300px", md: "515px", } }}>
                                <iframe
                                    src={videoPlayer.videoUrl}
                                    width="100%"
                                    // height="415px"
                                    height="100%"
                                    frameBorder="0"
                                    allow="autoplay; encrypted-media"
                                    allowFullScreen
                                    title="YouTube video"
                                />
                            </Box> */}



                                <Box sx={{ my: "10px", px: "10px" }}>
                                    <Typography sx={{ fontWeight: "bold", mb: "5px", textTransform: "capitalize" }}>{videoPlayer.videoTitle}</Typography>
                                </Box>
                            </Box>
                        </Box >
                    </>
                ) : <Box sx={{ mx: "30px" }}>
                    <Typography sx={{ display: "block", mb: 3 }}>No Videos Found</Typography>

                </Box>
                }

            </Box >
        </>

    )
}